<div class="header nav-top-wrapper">
  @if (showTopBar) {
    <nav class="top-navbar-container">
      <div class="top-navbar d-flex justify-content-between align-items-center">
        <div class="col-lg-2">
          @if (showTopBarSocialIcons) {
            <app-social-icons></app-social-icons>
          }
        </div>

        <nav class="top-navbar-nav col-lg-9 d-none d-lg-flex">
          <ul class="nav w-100 d-flex justify-content-end align-items-center">
            @if (isSearchAndCategoryVisible) {
              <li>
                <button class="navbar-category-button btn btn-primary d-none d-lg-flex mx-4 mx-xxl-5" data-bs-toggle="offcanvas" data-bs-target="#sidebar-category">
                  <i class="bi bi-list"></i>
                  @if (showCategoryFilterIcon && categoryFilterList != undefined && categoryFilterList.length > 0) {
                    <i class="bi bi-filter"></i>
                  }
                  <span i18n="@@NavTopCategories">Categories</span>
                </button>
              </li>
            }

            @for (link of topBarLinks; track link) {
              <li>
                <a class="nav-link mx-4 mx-xxl-5" [routerLink]="link.routerlink" [queryParams]="link.queryParams">
                  <span>{{ link.label }}</span>
                </a>
              </li>
            }
          </ul>
        </nav>

        <div class="contact-icons col-lg-1 d-flex justify-content-end">
          @if (contactEmail) {
            <a [href]="'mailto:' + contactEmail" target="_blank">
              <i class="bi bi-envelope"></i>
            </a>
          }

          @if (contactEmail && contactPhone) {
            <span class="vertical-line"></span>
          }

          @if (contactPhone) {
            <a [href]="'tel:' + contactPhone" target="_blank">
              <i class="bi bi-telephone"></i>
            </a>
          }
        </div>
      </div>
    </nav>
  }

  <nav class="navbar navbar-expand-lg navbar-dark" aria-label="navbartopmenu">
    <div class="container d-flex align-items-center">
      @if (showCategorySidebarWidget && isSearchAndCategoryVisible) {
        <span class="nav-link c-pointer d-lg-none d-flex align-items-center p-0" data-bs-toggle="offcanvas" data-bs-target="#sidebar-category">
          <i class="bi bi-list"></i>
        </span>
      }

      <a class="navbar-brand" [routerLink]="brandPage.routerlink" [queryParams]="brandPage.queryParams">
        <img role="img" class="brand-logo" alt="Logo" />
        <span class="brand-name">{{ brand }}</span>
      </a>

      @if (mainNavLinks && mainNavLinks.length > 0) {
        <nav class="main-nav d-none d-lg-flex">
          <ul class="nav">
            @for (link of mainNavLinks; track link) {
              <li class="nav-item mx-2 mx-xl-3 mx-xxl-4">
                <a class="nav-link" [routerLink]="link.routerlink" [queryParams]="link.queryParams" routerLinkActive="active-main-nav-link" [routerLinkActiveOptions]="{ exact: false }">
                  <span>{{ link.label }}</span>
                </a>
              </li>
            }
          </ul>
        </nav>
      }

      @if (showCategorySidebarWidget && !showTopBar && isSearchAndCategoryVisible) {
        <button class="navbar-category-button btn btn-primary d-none d-lg-flex mx-4 mx-xxl-5" data-bs-toggle="offcanvas" data-bs-target="#sidebar-category">
          <i class="bi bi-list"></i>
          @if (showCategoryFilterIcon && categoryFilterList != undefined && categoryFilterList.length > 0) {
            <i class="bi bi-filter"></i>
          }
          <span i18n="@@NavTopCategories">Categories</span>
        </button>
      }

      <div class="navbar-nav d-none d-lg-inline search-bar-wrapper flex-grow-1">
        <ng-container *ngTemplateOutlet="searchBar"></ng-container>
      </div>
      <div class="flex-grow-1 d-inline d-lg-none"></div>

      <div class="d-flex menu-icon-bar justify-content-end align-items-center" #navTopMenu>
        @if (showFavoriteButton == true) {
          <span
            class="menu-icon-link d-flex d-inline-block"
            id="favoriteTooltipContainer"
            data-bs-toggle="tooltip"
            data-bs-html="true"
            data-bs-sanitize="true"
            data-bs-delay="200"
            data-bs-placement="auto"
            [attr.data-bs-title]="favoriteTooltipHtmlContent"
          >
            <a class="circle d-flex justify-content-center align-items-center" [routerLink]="'/user/favorite'">
              <i class="bi bi-heart-fill fs-3"></i>
            </a>
          </span>
        }
        @if (showComparisonButton == true) {
          <span
            class="menu-icon-link d-flex d-inline-block"
            id="comparisonTooltipContainer"
            data-bs-toggle="tooltip"
            data-bs-html="true"
            data-bs-sanitize="true"
            data-bs-delay="200"
            data-bs-placement="auto"
            [attr.data-bs-title]="comparisonTooltipHtmlContent"
            (click)="compareNow()"
          >
            <a class="circle d-flex justify-content-center align-items-center">
              <i class="bi bi-arrow-left-right fs-3"></i>
            </a>
          </span>
        }
        @if (showOrderHistoryButton == true) {
          <span
            class="menu-icon-link d-flex d-inline-block"
            id="orderHistoryTooltipContainer"
            data-bs-toggle="tooltip"
            data-bs-html="true"
            data-bs-sanitize="true"
            data-bs-delay="200"
            data-bs-placement="auto"
            [attr.data-bs-title]="orderHistoryTooltipHtmlContent"
          >
            <a class="circle d-flex justify-content-center align-items-center" [routerLink]="'/user/order-list'">
              <i class="bi bi-clipboard-fill fs-3"></i>
            </a>
          </span>
        }
        @if (showOfferHistoryButton == true) {
          <span
            class="menu-icon-link d-flex d-inline-block"
            id="offerHistoryTooltipContainer"
            data-bs-toggle="tooltip"
            data-bs-html="true"
            data-bs-sanitize="true"
            data-bs-delay="200"
            data-bs-placement="auto"
            [attr.data-bs-title]="offerHistoryTooltipHtmlContent"
          >
            <a class="circle d-flex justify-content-center align-items-center" [routerLink]="'/user/offer-list'">
              <i class="bi bi-file-text-fill fs-3"></i>
            </a>
          </span>
        }
        @if (showRecentlySeenButton == true) {
          <span
            class="menu-icon-link d-flex d-inline-block"
            id="recentlySeenTooltipContainer"
            data-bs-toggle="tooltip"
            data-bs-html="true"
            data-bs-sanitize="true"
            data-bs-delay="200"
            data-bs-placement="auto"
            [attr.data-bs-title]="recentlySeenTooltipHtmlContent"
          >
            <a class="circle d-flex justify-content-center align-items-center" [routerLink]="'/product/recently'">
              <i class="bi bi-eye-fill fs-3"></i>
            </a>
          </span>
        }
        <app-language-button></app-language-button>
        @if (showUserButton == true) {
          <span class="menu-icon-link" data-bs-toggle="offcanvas" data-bs-target="#sidebar-user">
            @if (isAuthenticated == true) {
              <app-user-initials></app-user-initials>
            }
            @if (isAuthenticated != true) {
              <i class="bi bi-person"></i>
            }
          </span>
        }
        @if (showCartButton && isSearchAndCategoryVisible) {
          <span class="menu-icon-link menu-icon-link-cart" data-bs-toggle="offcanvas" data-bs-target="#sidebar-cart">
            <i class="bi bi-cart4"></i>
            <span>{{ shoppingCartItemCount }}</span>
          </span>
        }
      </div>
    </div>
    <div class="search-bar-container container d-inline d-lg-none mt-1">
      <div class="navbar-nav w-100">
        <ng-container *ngTemplateOutlet="searchBar"></ng-container>
      </div>
    </div>
  </nav>
  @if (showCategoryNavbar) {
    <app-category-nav-bar></app-category-nav-bar>
  }
</div>

<ng-template #searchBar>
  @if (isSearchAndCategoryVisible) {
    <div class="search nav-item dropdown w-100">
      <form class="input-group w-100 h-100">
        <button type="button" class="input-group-text py-0 px-3 btn-search" id="navbartopmenusearch" (click)="simulateEnterKey($event)">
          <i class="bi bi-search"></i>
        </button>
        <input
          type="text"
          class="form-control dropdown search-input"
          placeholder="Search"
          i18n-placeholder="@@NavTopMenuSearchPlaceholder"
          aria-label="Search"
          autocomplete="off"
          [ngModel]="searchText"
          name="searchText"
          (input)="searchTextKeypress($event)"
          (focus)="searchInputFocused = true"
          (blur)="searchInputFocused = false"
          (keydown)="navigateUsingKey($event)"
          (click)="searchInputFocused = true"
        />
      </form>
      @if (searchPreviewItemList && searchInputFocused) {
        <ul class="dropdown-menu show w-100 p-2">
          <li class="search-preview dropdown-item c-pointer p-0" (mousedown)="$event.preventDefault()" (click)="productSearch()" [class.selected-search-preview-item]="-1 === linkIndex">
            <span i18n="@@NavTopSearchPreviewCountPrefix">Found</span>
            <span> {{ searchPreviewItemList.length }} </span>
            <span i18n="@@NavTopSearchPreviewCoundtSuffix">products</span>
            @if (searchPreviewItemList.length > searchPreviewMaxCount) {
              <span> ...</span>
            }
          </li>
          @if (searchPreviewItemListSlice) {
            <hr class="dropdown-divider mx-0 my-1" />
            @for (searchPreviewItem of searchPreviewItemListSlice; track searchPreviewItem; let i = $index) {
              <li class="search-preview dropdown-item c-pointer p-0" [class.selected-search-preview-item]="i === linkIndex">
                <app-search-preview-item [searchPreviewItem]="searchPreviewItem" (onProductSearchResultClicked)="onProductSearchResultClick(searchPreviewItem)"> </app-search-preview-item>
              </li>
            }
            @if (searchPreviewItemList.length > searchPreviewMaxCount) {
              <hr class="dropdown-divider mx-0 my-1" />
              <li class="search-preview dropdown-item c-pointer p-0" (mousedown)="$event.preventDefault()" (click)="productSearch()" [class.selected-search-preview-item]="searchPreviewItemListSlice.length === linkIndex">
                <span>...</span>
              </li>
            }
          }
        </ul>
      }
    </div>
  }
</ng-template>
